import { render, staticRenderFns } from "./CardBenefitItem.vue?vue&type=template&id=5ef0b484&scoped=true"
import script from "./CardBenefitItem.vue?vue&type=script&lang=js"
export * from "./CardBenefitItem.vue?vue&type=script&lang=js"
import style0 from "./CardBenefitItem.vue?vue&type=style&index=0&id=5ef0b484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0b484",
  null
  
)

export default component.exports